import React, { FC, useEffect, useState } from 'react'
import { HTMLMotionProps, motion } from 'framer-motion'
import {
  messageAnimationPropsDiv,
  messageAnimationPropsDivContainer,
} from '@/utils/ai-assistant'
import { CommonTutorIsTypingMessage } from '@/components/ui/common/lessons/CommonTutorIsTypingMessage'

const TEXT_CHANGE_TIMEOUT_MS = 4500

interface Props {
  loadingTextParts: string[]
  divAnimationProps?: HTMLMotionProps<'div'>
  divContainerAnimationProps?: HTMLMotionProps<'div'>
  textChangeTimeout?: number
}

export const AiAssistantTutorIsLoadingMessageContent: FC<Props> = ({
  loadingTextParts,
  divAnimationProps = messageAnimationPropsDiv,
  divContainerAnimationProps = messageAnimationPropsDivContainer,
  textChangeTimeout = TEXT_CHANGE_TIMEOUT_MS,
}) => {
  const [currentText, setCurrentText] = useState<string | null>(null)
  const [currentTextKey, setCurrentTextKey] = useState(0)

  useEffect(() => {
    if (!loadingTextParts.length || textChangeTimeout === 0) return

    let index = 0
    setCurrentText(loadingTextParts[index])

    const interval = setInterval(() => {
      index = (index + 1) % loadingTextParts.length
      setCurrentText(loadingTextParts[index])
      setCurrentTextKey((prev) => prev + 1) // key change is used to trigger framer-motion animation each time text changed
    }, textChangeTimeout)

    return () => {
      clearInterval(interval)
    }
  }, [loadingTextParts, textChangeTimeout])

  return (
    <motion.div {...divContainerAnimationProps} className="w-full">
      <motion.div {...divAnimationProps} key={currentTextKey}>
        <CommonTutorIsTypingMessage
          text={currentText || ''}
          loaderColor="gray-800"
        />
      </motion.div>
    </motion.div>
  )
}
